import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7579f944"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed } from 'vue';
import { IonItem, IonLabel, IonInput } from '@ionic/vue';
import { ClampingTool } from '@/enums/Clamping';
import { useClampingStepStore } from '@/store/clampingStep';
import useTranslateEnums from '@/composables/useTranslateEnums';
import DropdownSelect from '@/components/DropdownSelect.vue';
import ComputeWizardStepContainer from '@/components/ComputeWizard/ComputeWizardStepContainer.vue';
import ComputeWizardInputAccordion from '@/components/ComputeWizard/ComputeWizardInputAccordion.vue';
import Clamping from '@/assets/images/step-schemas/clamping-tool.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeWizardClamping',
  emits: ['requestNextStep'],
  setup(__props) {



const clampingStepStore = useClampingStepStore();
const { translate } = useTranslateEnums();

const specificValueShouldBeDisplayed = computed(() => {
  return clampingStepStore.tool === undefined || clampingStepStore.tool?.toString() === '';
});

const toolList = computed(() => {
  return translate(ClampingTool, 'clamping.tools');
});

const onToolChange = () => {
  clampingStepStore.onToolUpdate();
};

const onSpecificSettingChange = () => {
  clampingStepStore.onSpecificUpdate();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputeWizardStepContainer, { class: "compute-wizard-clamping" }, {
    default: _withCtx(() => [
      _createVNode(DropdownSelect, {
        class: "compute-wizard-clamping__tool-list",
        label: _ctx.$t('clamping.tool_list_input_label'),
        modelValue: _unref(clampingStepStore).tool,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(clampingStepStore).tool) = $event)),
        options: toolList.value,
        onIonChange: onToolChange
      }, null, 8, ["label", "modelValue", "options"]),
      _createElementVNode("img", {
        class: "compute-wizard-clamping__image",
        src: _unref(Clamping)
      }, null, 8, _hoisted_1),
      _createVNode(ComputeWizardInputAccordion, {
        class: "compute-wizard-clamping__input-accordion",
        title: _ctx.$t('clamping.specific_settings.accordion_label'),
        "should-be-open": specificValueShouldBeDisplayed.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), {
            lines: "full",
            class: "compute-wizard-clamping__input-accordion-item",
            slot: "content"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('clamping.specific_settings.input_label')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonInput), {
                class: "compute-wizard-clamping__specific-input",
                type: "number",
                inputMode: "decimal",
                pattern: "[0-9]*",
                step: "0.1",
                min: "0.1",
                max: "100",
                modelValue: _unref(clampingStepStore).specificSetting,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(clampingStepStore).specificSetting) = $event)),
                onIonChange: onSpecificSettingChange,
                placeholder: "x",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('requestNextStep')), ["enter"]))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "should-be-open"])
    ]),
    _: 1
  }))
}
}

})